import axios from "axios";
import Swal from "sweetalert2";
import { AUTHENTICATION_URL, LOGIN_AUTHENTICATION_URL, LOGIN_AUTHENTICATION_URL_TOTP, LOGIN_PAGE_URL } from "./APIURLS";

export const CommonAjaxPostRequest = async (url, values, dispatch) => {
    let res = '';
    try {
        res = await axios({
            url: url,
            method: 'post',
            data: values,
        })
        if (res.status === 200) {
            // return response data if api response is 200
        }
        return res.data
    }
    catch (err) {
        console.error(err);
        failureResponse(err, dispatch);

    }
};
export const CommonAjaxPostRequestWithToken = async (url, values, dispatch) => {
    let res = '';
    let token = JSON.parse(localStorage.getItem("token"));
    try {
        res = await axios({
            url: url,
            method: 'post',
            data: values,
            headers: { Authorization: "Bearer " + token }
        })
        if (res.status === 200) {
            // return response data if api response is 200
        }
        return res
    }
    catch (err) {
        return err?.response;
        // console.error(err);
        // failureResponse(err, dispatch);

    }
};

export const CommonAjaxGetRequestWithOutParamsWithOutAuthorization = async (url, dispatch) => {

    let res = '';
    try {
        res = await axios({
            url: url,
            method: 'get',

        })
        if (res.status === 200) {
            // return response data if api response is 200
        }
        return res.data
    }
    catch (err) {
        console.error(err);
        failureResponse(err, dispatch);
    }
};

export const CommonAjaxGetRequestWithOutParams = async (url, dispatch) => {

    let token = JSON.parse(localStorage.getItem("token"));
    let res = '';
    try {
        res = await axios({
            url: url,
            method: 'get',
            headers: { Authorization: "Bearer " + token }
        })
        if (res.status === 200) {
            // return response data if api response is 200
        }

        return res.data
    }
    catch (err) {
        console.error(err);
        failureResponse(err, dispatch);
        dispatch({ type: 'HIDE_SPINNER', payload: { key: 'showSpinner', value: false } });
    }
};
export const CommonAjaxTokenInvalidate = async (url, dispatch) => {
    let refresh_token = JSON.parse(localStorage.getItem('refresh_token'))
    let res = ''
    let urlencoded = new URLSearchParams();
    if (refresh_token !== null) {
        urlencoded.append('refresh_token', refresh_token);
        let Headers = {
            'Content-Type': 'application/x-www-form-urlencoded',
            // "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "POST"
        }
        try {
            res = await axios.post(url, urlencoded, Headers);
            if (res.status === 200) {
                // return response data if api response is 200
            }
            return res.data
        }
        catch (error) {
            window.location.href = LOGIN_PAGE_URL
        }
        dispatch({ type: 'HIDE_SPINNER', payload: { key: 'showSpinner', value: false } });

    }
}
export function failureResponse(res, dispatch) {
    let errorMessage = "Something Went Wrong. Please Try again";
    if (res.response !== undefined) {
        if (res.response.status === 401 || res.response.status === 403) {
            errorMessage = "UnAuthorised Access";
        }
        else if ((res.response.status === 404) || (res.response.status === 500) || (res.response.status === 400)) {
            if (res.response.data.errorMessage !== null && res.response.data.errorMessage !== undefined && res.response.data.errorMessage.length > 0) {
                errorMessage = res.response.data.errorMessage;
            }
        }
    }
    else {
        errorMessage = 'Something Went Wrong. Please Try again';
    }
    Swal.fire({
        text: errorMessage,
        icon: 'error',
        confirmButtonColor: '#4962B3',
        confirmButtonText: 'Ok'
    }).then(function () {
        window.location.href = LOGIN_PAGE_URL
    });
    dispatch({ type: 'HIDE_SPINNER', payload: { key: 'showSpinner', value: false } });
}
export const CommonAjaxPostLoginRequest = async (url, values, dispatch, history) => {
    let res = '';
    try {
        res = await axios({
            url: url,
            method: 'post',
            data: values,
        })
        if (res.status === 200) {
            // return response data if api response is 200
        }
        return res.data
    }
    catch (err) {
        if (url === (AUTHENTICATION_URL || LOGIN_AUTHENTICATION_URL || LOGIN_AUTHENTICATION_URL_TOTP)) {
            localStorage.setItem("loginFailErrorMsg", err.response?.data?.errorMessage)
            if (err.response?.data?.passwordExpiry === true) {
                localStorage.setItem("passwordExpiry", JSON.stringify(err.response?.data?.passwordExpiry))
                Swal.fire({ text: err.response?.data?.message, icon: 'error', allowEnterKey: false, allowEscapeKey: false, allowOutsideClick: false }).then(function (isConfirm) {
                    if (isConfirm.value) {
                        history.push({ pathname: '/forgotPassword', state: 'passwordExpired' })
                    }
                })
            }
        }
        // return err;
    }
};
export const CommonAjaxPostLoginRequestUpdated = async (url, values, dispatch, history) => {
    let res = '';
    try {
        res = await axios({
            url: url,
            method: 'post',
            data: values,
        })
        if (res.status === 200) {
            // return response data if api response is 200
        }
        return res
    }
    catch (err) {
        // if (url === (AUTHENTICATION_URL || LOGIN_AUTHENTICATION_URL || LOGIN_AUTHENTICATION_URL_TOTP)) {
        //     localStorage.setItem("loginFailErrorMsg", err.response?.data?.errorMessage)
        //     if (err.response?.data?.passwordExpiry === true) {
        //         localStorage.setItem("passwordExpiry", JSON.stringify(err.response?.data?.passwordExpiry))
        //         Swal.fire({ text: err.response?.data?.message, icon: 'error', allowEnterKey: false, allowEscapeKey: false, allowOutsideClick: false }).then(function (isConfirm) {
        //             if (isConfirm.value) {
        //                 history.push({ pathname: '/forgotPassword', state: 'passwordExpired' })
        //             }
        //         })
        //     }
        // }
        return err?.response;
    }
};

export const CommonAjaxPostWithFileUpload = async (url, values) => {
    let res = '';
    try {
        res = await axios({
            url: url,
            method: 'post',
            async: false,
            contentType: false,
            processData: false,
            data: values,
        })
        if (res.status === 200) {
            // return response data if api response is 200
        }
        return res
    }
    catch (err) {
        console.error(err);
    }
};


export const CommonAjaxGetRequestWithOutParamsWithoutToken = async (url, dispatch) => {
    let res = '';
    try {
        res = await axios({
            url: url,
            method: 'get'
        })
        if (res.status === 200) {
            // return response data if api response is 200
        }

        return res.data
    }
    catch (err) {
        console.error(err);
        failureResponse(err, dispatch);
        dispatch({ type: 'HIDE_SPINNER', payload: { key: 'showSpinner', value: false } });
    }
};

export const CommonAjaxPdfADownloadlink = async (url, type,dispatch) => {
  let res = '';
  
  try {
    res = await axios({
      url: url,
      method: 'get',
      responseType: 'blob',
    })
    
    if (res.status === 200) {
      var a = document.createElement("a");
      document.body.appendChild(a);
      const file = new Blob(
        [res.data],
        { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);
      a.href = fileURL;
      a.download = type;
      a.target = '_blank';
      a.click();
      window.open(fileURL);
    }

  }
  catch (err) {
     console.error(err);
        failureResponse(err, dispatch);
  }
};